import { Component, ElementRef } from '@angular/core';

@Component({
  selector: 'app-sidebar-footer',
  templateUrl: './app-sidebar-footer.component.html'
})
export class AppSidebarFooter {

  constructor(private el: ElementRef) { }

  //wait for the component to render completely
  ngOnInit(): void {
    let nativeElement: HTMLElement = this.el.nativeElement,
    parentElement: HTMLElement = nativeElement.parentElement;
    // move all children out of the element
    while (nativeElement.firstChild) {
      parentElement.insertBefore(nativeElement.firstChild, nativeElement);
    }
    // remove the empty element(the host)
    parentElement.removeChild(nativeElement);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/app-sidebar/app-sidebar-footer/app-sidebar-footer.component.ts